import React from 'react';
import { Flex } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import styles from './SavedListPanel.module.css';

interface SavedListPanelShellProps {
  title: string;
  onBack: () => void;
  children: React.ReactNode;
}

/** The frame shared by the save-list and list-edit panels: a back arrow and
 * title above their form. */
const SavedListPanelShell: React.FC<SavedListPanelShellProps> = ({
  title,
  onBack,
  children,
}) => (
  <div className={styles.panel}>
    <Flex align='center' gap={8} className={styles.header}>
      <button
        type='button'
        className={styles.back}
        onClick={onBack}
        aria-label='Back'
      >
        <LeftOutlined />
      </button>
      <span className={styles.title}>{title}</span>
    </Flex>
    {children}
  </div>
);

export default SavedListPanelShell;
